import { useLayoutEffect, useMemo, useRef } from 'react'
import { Box } from '@mui/material'
import { DICTATION_BAR_COUNT } from './useDictationAudio'
import styles from './DictationWaveform.module.scss'

/**
 * @param {{
 *   levels: Float32Array,
 *   minBarPx: number,
 *   maxBarPx: number,
 * }} props
 */
function DictationWaveform({ levels, minBarPx, maxBarPx }) {
  const barElsRef = useRef(/** @type {Array<HTMLElement | null>} */ ([]))

  const bars = useMemo(() => {
    const out = []
    for (let i = 0; i < DICTATION_BAR_COUNT; i += 1) {
      const level = levels[i] ?? 0
      const h = minBarPx + level * (maxBarPx - minBarPx)
      const heightPx = Math.round(h * 10) / 10
      const isHot = heightPx > minBarPx + 0.5
      out.push({ key: i, heightPx, isHot })
    }
    return out
  }, [levels, minBarPx, maxBarPx])

  useLayoutEffect(() => {
    bars.forEach(({ key, heightPx }) => {
      const el = barElsRef.current[key]
      if (!el) return
      el.style.height = `${heightPx}px`
    })
  }, [bars])

  return (
    <Box className={styles.outer} aria-hidden>
      <Box className={styles.inner}>
        {bars.map(({ key, heightPx, isHot }) => (
          <Box
            component="span"
            key={key}
            className={`${styles.bar} ${isHot ? styles.barHot : styles.barDim}`}
            ref={(el) => {
              barElsRef.current[key] = el
            }}
            data-height={heightPx}
          />
        ))}
      </Box>
    </Box>
  )
}

export default DictationWaveform
